<template>
	<div class="dialog_scroll clearfix">
		<div class="taskIng_left">
			<div class="taskIng_infoHead" v-show="questionindex == index" v-for="(item,index) in qusetionlist">
				<img src="@/images/topic_type1.png" v-if="item.topicType == 1" />
				<img src="@/images/topic_type2.png" v-if="item.topicType == 2" />
				<img src="@/images/topic_type3.png" v-if="item.topicType == 3" />
				<img src="@/images/topic_type4.png" v-if="item.topicType == 4" />
				<img src="@/images/topic_type5.png" v-if="item.topicType == 5" />
			</div>
			<div class="taskQuestion_infobody clearfix">
				<questions @singleAnswer='({it,i,index})=>{singleAnswer(it,i,index)}' @multipleAnswer='({it,i,index})=>{multipleAnswer(it,i,index)}' @blanksAnswer='({index})=>{blanksAnswer(index)}' @uploadStatus="(newuploadFlag)=>{uploadFlag = newuploadFlag}" @uploadAnswer='uploadAnswer' @formFileRemove='formFileRemove' :taskType='true' :questionsubmit='false' :qusetionlist='qusetionlist' :questionindex='questionindex'></questions>
			</div>
			<div class="taskIng_infoFoot">
				<el-button @click="jumpQuestion(questionindex-1,'prve')" :disabled='questionindex<=0 || uploadFlag'>上一题</el-button>
				<el-button @click="jumpQuestion(questionindex+1,'next')" type="primary" :disabled='questionindex>=qusetionlist.length-1 || uploadFlag'>下一题</el-button>
			</div>
		</div>
		<div class="taskIng_right">
			<div class="taskIng_rightHead">答题卡</div>
			<div class="examIng_infobodyList">
				<div class="examIng_infobodyTitle">
					当前成绩：<span class="warningColor">{{userScore || "0"}}</span>
				</div>
				<div class="examIng_infobodyType success">正确</div>
				<div class="examIng_infobodyType error">错误</div>
				<div class="examIng_infobodyType warning">简答已批</div>
				<div class="examIng_infobodyType info">简答未批</div>
			</div>
			<div class="examIng_infobody clearfix">
				<div class="questionAnswer" :class="questionStatus(item,index)" v-for="(item,index) in qusetionlist" @click="jumpQuestion(index,'jump')">
					{{index+1}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { getUserTask, getTaskById } from '@/api/task.js'
	import { collectionSave, collectionDelete } from '@/api/collection'
	import questions from '@/components/questions.vue'
	import questionsjs from '@/components/questions.js'
	export default {
		mixins: [questionsjs],
		components: {
			questions
		},
		props: {
			taskId: String,
		},
		data() {
			return {
				userScore: 0,
				rightNum: 0,
				uploadFlag: false,
				testinfo: [],
				questionindex: 0,
				questionove: [],
				qusetionlist: [],
			}
		},
		created() {
			this.getTaskinfo();
			this.getTaskitem();
		},
		methods: {
			getTaskitem() {
				var data = {
					id: this.taskId
				}
				getTaskById(data).then(res => {
					if(res.code == "OK" && res.data) {
						this.taskinfo = res.data;
					}
				})
			},
			getTaskinfo() {
				var data = {
					taskId: this.taskId
				}
				getUserTask(data).then(res => {
					if(res.code == "OK") {
						this.userScore = res.data.score;
						this.rightNum = res.data.rightNum;
						var userAnswers = res.data.userAnswers;
						var qusetionlist = [];
						userAnswers.map(item => {
							var qusetionitem = Object.assign({}, item, item.tasktopic)
							qusetionitem.recoreId = item.id;
							qusetionitem.userScore = item.score;
							qusetionlist.push(qusetionitem);
						})
						this.qusetionlist = qusetionlist;
						this.formInitOver()
					}
				})
			},
			questionWhere(index) {
				var questionindex = this.questionindex;
				var questionove = this.questionove;
				if(index == questionindex) {
					return 'questionAnswer doing'
				} else if(questionove.indexOf(index) != -1) {
					return 'questionAnswer over'
				} else {
					return 'questionAnswer'
				}
			},
			jumpQuestion(questionindex) {
				if(this.questionindex != questionindex) {
					this.questionindex = questionindex
				}
			},
			toName(name) {
				if(this.$route.name != name) {
					this.$router.push({
						name
					})
				}
			},
		},
	}
</script>